export const QuestID = {
  CatFood: 3,
  AnimalShelter: 5,
  elenPackageQuest: 6,
  buyDrinkQuest: 7,
  helpDrunkenMother: 8,
  RubinaGymTip: 9,
  BirthdayGift: 12,
  EnergyDrink: 13,
  ItelligenceRise: 14,
  findHappiness: 15,
  findAnastasia: 16,
}
